export const RESPONSE_ERROR_MESSAGE = {
    0: 'OK',
    DEFAULT_ERROR_TEXT: '系统繁忙，请稍后再试',
    EXCEED_TIME_ERROR_TEXT: '接口超时',
    LOGIN_ERROR_TEXT: '请先登陆',
    NOT_LOGIN: '用户未登录',
    PERMISSION_DENIED: '用户没有权限',
    USER_NOT_EXIST: '用户不存在',
    USER_BANNED: '该账户已被管理账户禁用，无法登陆',
};
